module.exports = __webpack_public_path__ + "fonts/f062a09.otf";